import { render, staticRenderFns } from "./TabNotificationBubbleV2.vue?vue&type=template&id=3e5d9134&scoped=true"
import script from "./TabNotificationBubbleV2.vue?vue&type=script&lang=ts"
export * from "./TabNotificationBubbleV2.vue?vue&type=script&lang=ts"
import style0 from "./TabNotificationBubbleV2.vue?vue&type=style&index=0&id=3e5d9134&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d9134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5d9134')) {
      api.createRecord('3e5d9134', component.options)
    } else {
      api.reload('3e5d9134', component.options)
    }
    module.hot.accept("./TabNotificationBubbleV2.vue?vue&type=template&id=3e5d9134&scoped=true", function () {
      api.rerender('3e5d9134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabNotificationBubbleV2.vue"
export default component.exports